/** @format */

import { Link } from "react-router-dom";
import { useRef } from "react";
import { useClickOutside } from "../Hooks/UseClickOutside";
import { useAbout, useCloseField, useToggleField } from "../Store/MenuSlice";

export default function About({ child }) {
  const about = useAbout();
  const toggleFeild = useToggleField();

  const aboutRef = useRef(null);
  const buttonRef = useRef(null);
  const closeField = useCloseField();
  useClickOutside(
    aboutRef,
    () => {
      if (!child) closeField("about");
    },
    buttonRef
  );
  return (
    <>
      {!child && (
        <button
          className={`about-toggle ${about ? "prime-c" : "mixed-c"}`}
          ref={buttonRef}
          onClick={() => toggleFeild("about")}>
          About
        </button>
      )}

      <nav
        ref={aboutRef}
        className={`about-menu d-flex flex-column align-items-center index-4 ${!about ? "about-hide" : ""}`}>
        <Link to="/about">About</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to={"/about#feedback"}>Feedback</Link>
        <Link to={"/about#contact"}>Contact</Link>
        <button className="txt-start" onClick={() => toggleFeild("about")}>
          back
        </button>
      </nav>
    </>
  );
}
